// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  hmr: false,
  isPatient: false,
    authorizationApiToken_BEFORE: 'Basic TVUyODUwOTY3MTU0OjI4NVNmR3QzOHBXM3IzOTY5MjM0UnQyOFBsMjVQMjVVeVQ/Cg==',
  authorizationApiToken_AFTER: 'Basic TVUzOTY4MjU0Njc1OjI4NWxLdUkzN3BBNVAyOTU3NDUxR3Q0OUJ1Mjh3MjdQaVU/Cg=='
};
